import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';


interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading, isOnboardingRequired } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!user) {
      navigate('/', { replace: true });
    } else if (isOnboardingRequired) {
      navigate('/onboarding', { replace: true });
    }
  }, [user, isLoading, isOnboardingRequired, navigate]);

  if (isLoading || isOnboardingRequired) {
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return user && !isOnboardingRequired ? <>{children}</> : null;
};
